import Ajv, { ErrorObject, Schema } from 'ajv';
import ajvErrors from 'ajv-errors';
import addFormats from 'ajv-formats';
import { ValidationErrorResponse } from '../types';

const ajv = new Ajv({ allErrors: true });
addFormats(ajv);
ajvErrors(ajv);

export default {
    MISSING_FIELD_ERROR_MESSAGE: 'field is missing',
    SHOULD_NOT_CONTAIN_ADDITIONAL_FIELDS: 'No additional fields allowed in request',
};

/**
 * Accepts an object and a schema to be validated to utilize AJV library to perform validation.
 * @param json incoming JSON to be validated
 * @param schema Schema to be validated againstgit
 * @returns ValidationErrorResponse indicating a success or failure with errors.
 */

export const validate = (data: Record<string, any>, schema: Schema): ValidationErrorResponse | undefined => {
    const isValid = ajv.validate(schema, data);
    if (!isValid) {
        const validationErrors: ErrorObject[] = ajv.errors as ErrorObject[];

        return {
            errors: validationErrors.map((ajvError) => {
                const errorMessage = ajvError.message as string;
                return {
                    field: ajvError.params['missingProperty'] ?? ajvError.instancePath,
                    message: errorMessage,
                };
            }),
        };
    }
    return undefined;
};
